import React from "react";
import Agent from "./agent.jsx";
export const createBarberAvailability = async (shopId, availability) => {
  try {
    const token = localStorage.getItem("authToken");

    const params = {
      ShopId: shopId,
      BarberId: availability.BarberId,
      Day: availability.day, // e.g. "Monday" or number (0-6)
      StartTime: availability.startTime, // "09:00:00"
      EndTime: availability.endTime, // "17:00:00"
    };

    const { requests } = Agent();
    return await requests.post(`/BarberAvailability`, params, token, shopId);
  } catch (error) {
    console.error(
      "Error updating barber availability:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const updateBarberAvailability = async (shopId, availability) => {
  try {
    const token = localStorage.getItem("authToken");
    const params = {
      ShopId: shopId,
      BarberId: availability.staffId,
      Id: availability.id,
      Day: availability.day, // e.g. "Monday" or number (0-6)
      startTime: availability.startTime, // "09:00:00"
      endTime: availability.endTime, // "17:00:00"
    };
    const { requests } = Agent();
    return await requests.put(`/BarberAvailability/`, params, token, shopId);
  } catch (error) {
    console.error(
      "Error updating barber availability:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getbarberAvailabilty = async (shopId, barberId) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const token = localStorage.getItem("authToken");
  const params = {
    barberId: barberId, //ensure it's formatted correctly
    shopId: shopId,
  };
  const { requests } = Agent();
  return await requests.getAtt(`/BarberAvailability/`, params, token, shopId);
};

export const deleteBarberAvailability = async (
  shopId,
  barberId,
  availabilityId
) => {
  try {
    const token = localStorage.getItem("authToken");
    const params = {
      ShopId: shopId,
      BarberId: barberId,
      Id: availabilityId,
    };
    const { requests } = Agent();
    return await requests.del(
      `/BarberAvailability?id=${availabilityId}&barberId=${barberId}&shopId=${shopId}`,
      token,
      shopId
    );
  } catch (error) {
    console.error(
      "Error updating barber availability:",
      error.response?.data || error.message
    );
    throw error;
  }
};
